import React from 'react';
import PropTypes from 'prop-types';

import styles from './website-banner.scss';

const WebsiteBanner = ({ headline, children, image1, image2, image3 }) => (
  <div className={styles.websiteBanner}>
    <div className={styles.websiteBannerInnerWrapper}>
      <div className={styles.websiteBannerInner}>
        <div className={styles.content}>
          <div>
            <h1>{headline}</h1>
            {children}
          </div>
        </div>

        <div className={styles.images}>
          <div>
            <div className={styles.imagesContainer}>
              <div className={styles.imageContainer}>
                <img src={image3} className={styles.image} alt="" />
              </div>
              <div className={styles.imageContainer}>
                <img src={image2} className={styles.image} alt="" />
              </div>
              <div className={styles.imageContainer}>
                <img src={image1} className={styles.image} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

WebsiteBanner.propTypes = {
  headline: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired,
  image1: PropTypes.string.isRequired,
  image2: PropTypes.string.isRequired,
  image3: PropTypes.string.isRequired,
};

export default WebsiteBanner;



// WEBPACK FOOTER //
// ./blocks/WebsiteBanner/index.js